import { BrowserRouter, Link, Navigate, Route, Routes } from "react-router-dom";

import Historical from "./Historical/Historical";
import Today from "./Today/Today";
import TodayAll from "./TodayAll/TodayAll";

function App() {
  return (
    <BrowserRouter>
      <nav>
        <Link to="/today">Today's Signal</Link>
        {" | "}
        <Link to="/history">Historical Data</Link>
        {" | "}
        <Link to="/today-all">Today's All Models Signal</Link>
      </nav>

      <Routes>
        <Route path="/today-all" element={<TodayAll />} />
        <Route path="/today" element={<Today />} />
        <Route path="/history" element={<Historical />} />
        <Route path="/" element={<Navigate to="/today" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
